import { useEffect } from "react";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";
import { ADD_VHEICLE_READING, VEHICLE_READING_SETUP } from "../apiEndPoints";
import AddVehicleReadingForm from "../forms/AddVehicleReadingForm";
import VehicleReadingDialog from "../components/dialogs/VehicleReadingDialog";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import spin from "../../../assets/icons/spin.png";

const AddVehicleReadingPage = () => {
  const { data, isLoaded, error, getData } = useGetData();
  const { executePost, loading, formError, successResponse, setFormError } =
    usePostData();
  useEffect(() => {
    getData(VEHICLE_READING_SETUP);
  }, []);

  const sendData = async (formValues, reset) => {
    // send data into form data
    const formData = new FormData();
    Object.entries(formValues).forEach(([key, value]) => {
      // Handle array values
      if (Array.isArray(value) && key !== "station_ids") {
        value.forEach((item) => formData.append(`${key}`, item));
      } else if (value !== "" && value !== null && value !== undefined) {
        // Append only non-empty, non-null, and defined values
        formData.append(key, value);
      }
    });
    //API calling
    executePost(formData, ADD_VHEICLE_READING, reset);
  };

  console.log(data, "data")
  return (
    <MainPageLayout headerConfig={{ title: "Add Vehicle Reading" }}>
      {isLoaded && !error ? (
        <AddVehicleReadingForm
          loading={loading}
          sendData={sendData}
          setupData={data.stations}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
      {successResponse && (
        <VehicleReadingDialog success={true} details={successResponse} />
      )}
    </MainPageLayout>
  );
};

export default AddVehicleReadingPage;
